import { generatePath, Navigate } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { VoucherI18nEditPresenter } from "./presenter";
import { useVoucherI18nEditQuery } from "../../model/repository/existing/query/use-voucher-i18n-edit-query";

type Props = {
	hotelID: string;
	voucherID: string;

	activeLangCode?: LangCode;
	navigator?: {
		default: string;
		i18n: (langCode: LangCode) => string;
	};
};

export const VoucherI18nEditContainer = ({ hotelID, voucherID, navigator, activeLangCode }: Props) => {
	const serverModel = useVoucherI18nEditQuery({ hotelID, voucherID, lang: activeLangCode ?? LangCode.Default });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <VoucherI18nEditPresenter serverModel={serverModel} navigator={navigator} activeLangCode={activeLangCode} />;
};

VoucherI18nEditContainer.displayName = "VoucherI18nEditContainer";
